import React from "react";
import GraphView from "../graph/graphview"


// @ts-ignore
function Graph(props) {
  return (
    <GraphView {...props}/>
  )
}

export default Graph;